import React from 'react';

import { Col } from 'reaxl';
import { InventoryListingPlaceholder } from 'reaxl-listing';

function SimilarInventoryContainerPlaceholder() {
    // Placeholder for 20 listings plus the Transition Card
    return Array(21).fill().map((_, index) => (
        <Col
            xs={12}
            sm={6}
            md={4}
            key={`inventory-placeholder-simListings-${index}`}
        >
            <InventoryListingPlaceholder
                data-cmp="inv-placeholder-simListings"
            />
        </Col>
    ));
}

export default SimilarInventoryContainerPlaceholder;
